export default __webpack_public_path__ + "static/media/wohnungen_intro_web-md@1x.0376929a.webp";